import React, { Component, InputHTMLAttributes } from "react";
import moment from "moment";
import { I8N } from "@eres/core";
import _ from "lodash";

export interface Props {
	id: string;
	value?: Date;
	opts?: object;
	onDateSet?: ( value?: Date ) => void;
	inputClassName?: string;
	containerClassName?: string;
	error?: string;
	placeholder?: string;
	errorInputClass?: string;
	disable?: boolean;
	inputProps?: Partial<InputHTMLAttributes<HTMLInputElement>>;
}

const ArDefaults = {
	closeText: "إغلاق",
	prevText: "&#x3C;السابق",
	nextText: "التالي&#x3E;",
	currentText: "اليوم",
	monthNames: [ "يناير", "فبراير", "مارس", "ابريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر" ],
	monthNamesShort: [ "يناير", "فبراير", "مارس", "ابريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر" ],
	dayNames: [ "الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت" ],
	dayNamesShort: [ "الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت" ],
	dayNamesMin: [ "ح", "ن", "ث", "ر", "خ", "ج", "س" ],
	weekHeader: "أسبوع",
	dateFormat: "dd/mm/yy",
	firstDay: 6,
	isRTL: true,
	showMonthAfterYear: false,
	yearSuffix: ""
};

function ToDate( input: any ) {
	let d: Date | undefined = undefined;
	if ( typeof input == "string" ) {
		d = ( input as string ).asDate();
	} else d = input;
	return d;
}

class DatePickerInput extends Component<Props> {
	static defaultProps: Partial<Props> = {
		containerClassName: "form-group",
		inputClassName: "form-control",
		errorInputClass: "form-input-error is-invalid",
		opts: {
			changeMonth: true,
			changeYear: true,
			dateFormat: "dd-mm-yy",
		}
	};
	$ = () => {
		return window.$( "#date-picker-inp-" + this.props.id );
	};
	onSelect = ( v1: any, v2: any ) => {
		let d = this.$().datepicker( "getDate" );
		let x = d ? moment( d ).startOf( "day" ) : undefined;
		if ( this.props.onDateSet ) this.props.onDateSet( x ? x.toDate() : undefined );

	};

	componentWillReceiveProps( nextProps: Readonly<Props>, nextContext: any ): void {
		let value = nextProps.value;
		if ( this.props.value !== value ) {
			requestAnimationFrame( () => {
				this.$().datepicker( "setDate", ToDate( value ) );
			} );
		}
		if ( !_.isEqual( this.props.opts, nextProps.opts ) ) {
			requestAnimationFrame( () => {
				this.$().datepicker( "option", nextProps.opts );
			} );

		}
	}

	componentDidMount(): void {
		if ( I8N.locale() === "ar" ) {
			window.$.datepicker.setDefaults( ArDefaults );
		}
		const props = this.props;
		let jq = this.$();
		jq.change( function () {
			requestAnimationFrame( () => {
				jq.datepicker( "setDate", jq.datepicker( "getDate" ) );
			} );

		} )
		.datepicker( {
			...props.opts,
			autoclose: true,
			onSelect: this.onSelect,
		} );
		if ( props.value ) {
			jq.datepicker( "setDate", ToDate( props.value ) );
		}
		if ( this.props.disable ) {
			jq.datepicker( "disable", props.disable );
		}
	}

	hookOnBlur = ( inputProps?: Partial<InputHTMLAttributes<HTMLInputElement>> ) => {
		const ip: Partial<InputHTMLAttributes<HTMLInputElement>> = inputProps ? { ...inputProps } : {};
		ip.onBlur = ( x ) => {
			if ( x.relatedTarget == null )
				requestAnimationFrame( () => {
					this.onSelect( null, null );
				} );
			if ( inputProps?.onBlur ) inputProps!.onBlur( x );
		};
		return ip;
	};

	render() {
		const { id, placeholder, inputClassName, errorInputClass, error, disable, inputProps } = this.props;
		let className = inputClassName + ( error ? ` ${ errorInputClass }` : "" );
		const ip = this.hookOnBlur( inputProps );
		return (
			<input
				type="text" className={ className } name={ id } id={ "date-picker-inp-" + id } disabled={ disable }
				placeholder={ placeholder } { ...ip }/>
		);
	}
}

export default DatePickerInput;
